import React, { Component } from 'react';
import './UserDetailsPage.css';
import Page from '../../components/page/Page';
import InventoryCheckCard from '../dashboardPage/inventoryCheckCard/InventoryCheckCard';
import UserDetailsCard from '../../cards/userDetailsCard/UserDetailsCard';
import DrugAdministrationCard from '../../components/drugAdministrationCard/DrugAdministrationCard';

export default class UserDetailsPage extends Component {
	render() {
		return (
			<Page className="g-user-details-page">
				<InventoryCheckCard userId={this.props.match.params.id} />
				<DrugAdministrationCard userId={this.props.match.params.id} />
				<UserDetailsCard userId={this.props.match.params.id} />
			</Page>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/userDetailsPage/UserDetailsPage.jsx